import { usePublicViewsWithSuspense } from "@swivu/client-api";
import ViewClients from "@swivu/shared-ui/src/components/ViewClients.js";
import { useParams } from "react-router-dom";

const ViewClientsPublic = () => {
  const { id, slug } = useParams<{ id: string; slug: string }>();
  const { data } = usePublicViewsWithSuspense({
    variables: {
      slug: slug as string
    },
    networkMode: "offlineFirst"
  });
  const boardId = data.find((view) => view.id === Number(id))?.board;
  if (!boardId) {
    return <div>Board not found</div>;
  }
  return (
    <ViewClients.Provider boardId={boardId} id={id!} api="public" slug={slug!}>
      <ViewClients />
    </ViewClients.Provider>
  );
};

export default ViewClientsPublic;
